import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import InfiniteScroll from 'react-infinite-scroller'
import styled from 'styled-components'

const ItemTileGridStyles = styled.section`
  ${props => props.gridStyles};

  .products-grid.non-auto:not(.paginated)
    .product:nth-of-type(n + ${props => props.numToInitialHide}) {
    display: none;
  }
`
class ItemTileGrid extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      paginated: false
    }

    this.setNumberOfTilesPerRow = this.setNumberOfTilesPerRow.bind(this)
  }

  setNumberOfTilesPerRow () {
    let styles = ''

    for (const screenWidth in this.props.tilesPerRow) {
      const numCards = this.props.tilesPerRow[screenWidth]

      const style = `
        @media(min-width: ${screenWidth}px) {
          .product {
            width: ${100.0 / numCards}%
          }
        }\n`
      styles = styles.concat(style)
    }

    return styles
  }

  render () {
    let baseClassNames = ['products-container', 'products-grid']
    if (this.props.additionalClassNames) {
      baseClassNames = baseClassNames.concat(this.props.additionalClassNames)
    }

    const itemGridClassName = classNames(baseClassNames, {
      'product-cards-loading': this.props.isLoading,
      'compact-xs tile-view': this.props.layout === 'tile',
      'list-view': this.props.layout === 'list',
      'non-auto': !this.props.autopaginate,
      paginated: this.state.paginated
    })

    let loadingCards

    if (this.props.isLoading) {
      loadingCards = new Array(12).fill(null).map((card, idx) => (
        <div key={idx} className='product loading'>
          <div className='product-card-loading-container' />
        </div>
      ))
    }

    const loadMoreTiles = () => {
      if (!this.props.isLoading) {
        this.props.onLoadMore()
      }
    }

    let seeMoreButton

    /**
     * See More button will appear when grid is not autopaginating and either has more entries
     * or it has not been paginated but the number of entries that are already loaded or
     * is more than or equal to the number showing but less than the total number of items.  This is because
     * we initially hide some already loaded entries to show a smaller grid.
     */
    if (
      !this.state.autopaginate &&
      ((!this.state.paginated &&
        this.props.itemsLength <= this.props.totalItems &&
        this.props.itemsLength > this.props.numInitialShow) ||
        this.props.hasMore)
    ) {
      seeMoreButton = (
        <div className='button-container center'>
          <a
            href='#'
            className='see-more'
            onClick={e => {
              e.preventDefault()
              if (this.state.paginated) {
                loadMoreTiles()
              } else {
                this.setState({ paginated: true })
              }
            }}
          >
            {this.props.seeMoreBtnLabel}
          </a>
        </div>
      )
    }

    return (
      <ItemTileGridStyles
        gridStyles={this.setNumberOfTilesPerRow()}
        numToInitialHide={this.props.numInitialShow + 1}
      >
        <InfiniteScroll
          hasMore={this.props.hasMore}
          loadMore={() => {
            if (this.props.autopaginate) loadMoreTiles()
          }}
          threshold={this.props.scrollThreshold}
        >
          <div className={itemGridClassName}>
            {this.props.renderItemTiles()}
            {loadingCards}
          </div>
          {seeMoreButton}
        </InfiniteScroll>
      </ItemTileGridStyles>
    )
  }
}

ItemTileGrid.defaultProps = {
  scrollThreshold: 500,
  autopaginate: true,
  tilesPerRow: {
    768: 1,
    992: 2,
    1200: 3
  }
}

ItemTileGrid.propTypes = {
  additionalClassNames: PropTypes.array,
  autopaginate: PropTypes.bool,
  hasMore: PropTypes.bool,
  layout: PropTypes.string,
  onLoadMore: PropTypes.func,
  isLoading: PropTypes.bool,
  renderItemTiles: PropTypes.func,
  scrollThreshold: PropTypes.number,
  seeMoreBtnLabel: PropTypes.string,
  tilesPerRow: PropTypes.object,
  numInitialShow: PropTypes.number,
  totalItems: PropTypes.number,
  itemsLength: PropTypes.number
}

export default ItemTileGrid
